<link rel="ractive" href="./package-request-bandwidth-stats.html" name="c-package-request-bandwidth-stats">
<link rel="ractive" href="./periods-dropdown.html" name="c-periods-dropdown">
<link rel="ractive" href="./top-stats-table.html" name="c-top-stats-table">
<link rel="ractive" href="./version-dropdown.html" name="c-version-dropdown">

<div class="header">
	<div class="header-title">Statistics</div>
	<div class="header-ctrls">
		<div class="data-range-ctrl">
			<span>Data range:</span>

			<c-periods-dropdown selectedValue="{{periodData.periodValue}}" selectHandler="{{@this.handlePeriodSelecting()}}"></c-periods-dropdown>
		</div>
	</div>
</div>

{{#if tabRoute === NAV_MENU_TABS.stats}}
	<c-package-request-bandwidth-stats
		name="{{name}}"
		type="{{type}}"
		periodData="{{periodData}}">
	</c-package-request-bandwidth-stats>
{{/if}}

{{#if noPackageStatsData}}
	<div class="no-data-wrapper">
		<img width="180" height="152" src="{{@shared.assetsHost}}/img/no-data-chart-main.svg">
		<span>No statistics yet</span>
		<span>This is probably not a very popular package :(</span>
	</div>
{{else}}
	<div class="chart-stats-per-period">
		<div class="package-usage">
			<div class="small-headline">{{chartTitlePeriodText}} {{~/periodData.periodText}}</div>

			<div class="chart-type-ctrl">
				<span>Show numbers of</span>

				<input id="chart-switch"
					type="checkbox"
					class="chart-type-switch {{#if showChartBandwidth}}checked{{/if}}"
					twoway="false">

				<label for="chart-switch" on-click="@this.set('showChartBandwidth', !showChartBandwidth)">
					<span>Requests</span>
					<span>Bandwidth</span>
					<div class="slide-select">
						<div class="selected"></div>
					</div>
				</label>
			</div>

			<div class="group-by-ctrl">
				<span>
					Group by:
				</span>

				<div class="btn-group">
					<button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span>{{~/usageChartGroupByValues[usageChartGroupBy].value}}</span>
						<i class="fa fa-angle-down" aria-hidden="true"></i>
					</button>

					<ul class="dropdown-menu">
						{{#each ~/usageChartGroupByValues}}
							<li>
								{{#if this.isAvailable}}
									<a on-click="@this.set('usageChartGroupBy', @key)">{{this.value}}</a>
								{{/if}}
							</li>
						{{/each}}
					</ul>
				</div>
			</div>
		</div>

		{{#if (noStatsChartHitsData && !showChartBandwidth) || (noStatsChartBandData && showChartBandwidth)}}
			<div class="stats-chart-no-data">
				<img
					width="270"
					height="148"
					src="{{@shared.assetsHost}}/img/landing/new/no-results.svg">
				<span>No data</span>
			</div>
		{{else}}
			<div class="stats-chart-wrapper">
				<canvas id="stats-chart"></canvas>
			</div>
		{{/if}}
	</div>

	<div class="horizontal-divider"></div>

	<div class="chart-tops">
		{{#if (noTopFiveHitsData && !showChartBandwidth) || (noTopFiveBandData && showChartBandwidth)}}
			<div class="chart-tops-no-data">
				<img
					width="270"
					height="148"
					src="{{@shared.assetsHost}}/img/landing/new/no-results.svg">
				<span>No data for Top versions</span>
			</div>
		{{else}}
			<c-top-stats-table
				title="Top versions"
				responseData="{{~/topVersions}}"
				responseHeaders="{{topVersionsHeaders}}"
				version="{{~/fileStatsVersion}}"
				isBandwidth="{{~/showChartBandwidth}}"
				pageLimit="{{topTablesLimit}}"
				page="{{topPackagesPage}}">
				{{#partial column1}}
					<a on-click="@this.set('version', version)">{{version}}</a>
				{{/partial}}
			</c-top-stats-table>

			<c-top-stats-table
				type="{{~/type}}"
				name="{{~/name}}"
				responseData="{{~/filesStats}}"
				responseHeaders="{{filesStatsHeaders}}"
				version="{{~/fileStatsVersion}}"
				versions="{{~/packageVersionsList}}"
				isBandwidth="{{~/showChartBandwidth}}"
				pageLimit="{{topTablesLimit}}"
				page="{{filesStatsPage}}"
				handleVersionChange="true">
				{{#partial header}}
					Top files in version
					<c-version-dropdown versions="{{versions}}" version="{{version}}"></c-version-dropdown>
				{{/partial}}

				{{#partial column1}}
					<a title="{{file}}" target="_blank" rel="noopener noreferrer" href="https://cdn.jsdelivr.net/{{~/type}}/{{~/name}}@{{~/version}}{{file}}">
						{{file}}
					</a>
				{{/partial}}
			</c-top-stats-table>
		{{/if}}
	</div>

	<div class="horizontal-divider"></div>

	<div class="chart-hits-per-period">
		<div class="package-usage">
			<div class="small-headline">{{#if showChartBandwidth}}Bandwidth{{else}}Requests{{/if}} per {{~/periodData.periodText}} per version</div>
		</div>

		{{#if (noHitsChartHitsData && !showChartBandwidth) || (noHitsChartBandData && showChartBandwidth)}}
			<div class="hits-chart-no-data">
				<img
					width="270"
					height="148"
					src="{{@shared.assetsHost}}/img/landing/new/no-results.svg">
				<span>No data</span>
			</div>
		{{else}}
			<div class="hits-chart-wrapper">
				<canvas id="hits-chart"></canvas>
			</div>

			<div class="hits-chart-legend">
				{{#each hitsChartLegendVersions:idx}}
					<div class="legend-item">
						<div style="background: {{colorsArray[idx]}};"></div>
						{{version}}
					</div>
				{{/each}}
			</div>
		{{/if}}
	</div>
{{/if}}

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const stats = require('../../assets/js/utils/stats');
	const listeners = require('../../assets/js/utils/listeners');
	const initCharts = require('../../assets/js/utils/charts');
	const DEFAULT_LIMIT = 5;
	const COLORS_ARR = [
		'#5C667A', '#BC5090', '#FFA600', '#FF6361', '#69C4F7',
		'#018b01', '#ffd68b', '#056ca6', '#c6302e', '#f53daa',
		'#aa0065', '#4eff4e', '#c79331', '#ffec00', '#FF6361',
		'#a2a9b6', '#dd8cbc', '#fab996', '#009ff9', '#709e11',
	];

	component.exports = {
		computed: {
			usageChartGroupByValues () {
				return stats.groupByOptions[this.get('periodData').periodType];
			},
		},
		data () {
			return {
				_,
				colorsArray: COLORS_ARR,
				periodData: { periodText: 'quarter', periodValue: 'quarter', periodType: 's-quarter' },
				showChartBandwidth: false,
				usageChartGroupByValues: stats.groupByOptions['s-quarter'],
				usageChartGroupBy: 'day',
				noPackageStatsData: false,
				chartTitlePeriodText: 'Stats for past',
				topTablesLimit: DEFAULT_LIMIT,
				topPackagesPage: 1,
				filesStatsPage: 1,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				// fetch Package Version File Stats for Top-files-per-package-version
				this.observe('periodData fileStatsVersion showChartBandwidth topTablesLimit filesStatsPage', () => {
					if (!this.get('periodData') || !this.get('fileStatsVersion')) {
						return;
					}

					let version = this.get('fileStatsVersion');
					let period = this.get('periodData').periodValue;
					let showChartBandwidth = this.get('showChartBandwidth');
					let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
					let type = this.get('type');
					let name = this.get('name');
					let filesStatsPage = this.get('filesStatsPage');
					let topTablesLimit = this.get('topTablesLimit');

					http.fetchPackageFileStatsWithHeaders(type, name, version, period, dataType, topTablesLimit, filesStatsPage).then(({ response, responseHeaders }) => {
						let filesStats = response.map(statsPerFile => ({
							file: statsPerFile.name,
							hits: statsPerFile[dataType].total,
						}));

						this.set('filesStats', filesStats);
						this.set('filesStatsHeaders', responseHeaders);
					});
				});

				// get Package Version Stats for Top-package-versions
				this.observe('periodData versionP showChartBandwidth topPackagesPage topTablesLimit', () => {
					if (!this.get('periodData') || !this.get('versionP')) { return; }

					let type = this.get('type');
					let name = this.get('name');
					let period = this.get('periodData').periodValue;
					let showChartBandwidth = this.get('showChartBandwidth');
					let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
					let limit = this.get('topTablesLimit');
					let page = this.get('topPackagesPage');

					http.fetchPackageVersionsStatsWithHeaders(type, name, period, dataType, limit, page).then(({ response, responseHeaders }) => {
						let {
							noHitsData: noTopFiveHitsData,
							noBandwidthData: noTopFiveBandData,
						} = this.checkPackageVersionsDataStatus(response);

						this.set('noTopFiveHitsData', noTopFiveHitsData);
						this.set('noTopFiveBandData', noTopFiveBandData);

						if (noTopFiveHitsData && noTopFiveBandData) {
							this.set('fileStatsVersion', null);
							this.set('topVersions', null);

							return;
						}

						let versionsStats = response.map(statsPerVersion => ({
							version: statsPerVersion.version,
							hits: statsPerVersion[dataType].total,
						}));

						if (
							versionsStats[0] && (
								(!noTopFiveHitsData && !noTopFiveBandData)
								|| (!noTopFiveHitsData && !showChartBandwidth)
								|| (!noTopFiveBandData && showChartBandwidth)
							)
						) {
							this.set('fileStatsVersion', versionsStats[0].version);
						}

						this.set('topVersions', versionsStats);
						this.set('topVersionsHeaders', responseHeaders);
						this.set('filesStatsPage', 1);
					});
				});

				// handle period changes by updating groupBy options and fetch statsChart/hitsChart data
				this.observe('periodData topTablesLimit topPackagesPage', () => {
					let period = this.get('periodData').periodValue;
					let type = this.get('type');
					let name = this.get('name');
					let dataType = this.get('showChartBandwidth') ? 'bandwidth' : 'hits';
					let limit = this.get('topTablesLimit');
					let page = this.get('topPackagesPage');

					// prevent chart data fetching from the back when period is DAY, left it as it was prev
					if (period === 'day') { return; }

					// get data for barChart
					http.fetchPackageSummaryStats(type, name, period).then((response) => {
						if (!response.hits.total && !response.bandwidth.total) {
							this.set('noStatsChartHitsData', true);
							this.set('noStatsChartBandData', true);
							this.set('rawStatsChartData', null);

							return;
						} else if (!response.hits.total) {
							this.set('noStatsChartHitsData', true);
						} else if (!response.bandwidth.total) {
							this.set('noStatsChartBandData', true);
						} else {
							this.set('noStatsChartHitsData', false);
							this.set('noStatsChartBandData', false);
						}

						// once new data fetched we should set groupBy to default value before raw data set
						this.set('usageChartGroupBy', 'day');
						this.set('rawStatsChartData', response);
					});

					// get data for lineChart
					http.fetchPackageVersionsStatsWithHeaders(type, name, period, dataType, limit, page).then(({ response }) => {
						let {
							noHitsData: noHitsChartHitsData,
							noBandwidthData: noHitsChartBandData,
						} = this.checkPackageVersionsDataStatus(response);

						this.set('noHitsChartHitsData', noHitsChartHitsData);
						this.set('noHitsChartBandData', noHitsChartBandData);

						if (noHitsChartHitsData && noHitsChartBandData) {
							this.set('rawHitsChartData', null);

							return;
						}

						// once new data fetched we should set groupBy to default value before raw data set
						this.set('usageChartGroupBy', 'day');
						this.set('rawHitsChartData', response);
					});
				});

				// get data for lineChart when Request/Bandwidth switch clicked (since it is sorting on the server)
				this.observe('showChartBandwidth', (showChartBandwidth) => {
					let period = this.get('periodData').periodValue;
					let type = this.get('type');
					let name = this.get('name');
					let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
					let limit = this.get('topTablesLimit');
					let page = this.get('topPackagesPage');

					http.fetchPackageVersionsStatsWithHeaders(type, name, period, dataType, limit, page).then(({ response }) => {
						let {
							noHitsData: noHitsChartHitsData,
							noBandwidthData: noHitsChartBandData,
						} = this.checkPackageVersionsDataStatus(response);

						this.set('noHitsChartHitsData', noHitsChartHitsData);
						this.set('noHitsChartBandData', noHitsChartBandData);

						if (noHitsChartHitsData && noHitsChartBandData) {
							this.set('rawHitsChartData', null);

							return;
						}

						this.set('rawHitsChartData', response);
					});
				}, { init: false });

				// handle raw StatsChart data and prepare it for StatsChart
				// screenWidth to observe when screen width is resized to recreate stats chart
				this.observe('rawStatsChartData showChartBandwidth usageChartGroupBy screenWidth', () => {
					let rawStatsChartData = this.get('rawStatsChartData');
					let showChartBandwidth = this.get('showChartBandwidth');

					if (
						!rawStatsChartData
						|| (!rawStatsChartData.hits.total && !showChartBandwidth)
						|| (!rawStatsChartData.bandwidth.total && showChartBandwidth)
						|| (!rawStatsChartData.hits.total && !rawStatsChartData.bandwidth.total)
					) { return; }

					let chartPeriodType = this.get('periodData').periodType;
					let usageChartGroupBy = this.get('usageChartGroupBy');
					let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;
					let dataType = showChartBandwidth ? 'bandwidth' : 'hits';

					// collect X-Axis dates, group data by period, get
					let {
						values,
						labels,
						labelsStartEndPeriods,
						maxRangeValue,
						valueUnits,
					} = _.getPreparedDataForBarChart(rawStatsChartData[dataType], usageChartGroupBy, chartPeriodType, showChartBandwidth);

					// get bat thickness of the chart depending on screen resolution, chartPeriodType and groupBy
					let chartBarThickness = _.calcChartBarThicknessByResolution(chartPeriodType, usageChartGroupBy);

					// set prepared data for chart
					this.set('preparedStatsChartData', {
						data: values,
						labels,
						labelsStartEndPeriods,
						maxRangeValue,
						showChartBandwidth,
						barThickness: chartBarThickness,
						useYAxisBorderPlugin: screenWidth >= 768,
						yAxisPadding: screenWidth >= 768 ? 20 : 8,
						valueUnits,
						usageChartGroupBy,
					});
				}, { init: false, defer: true });

				// handle raw HitsChart data and prepare it for HitsChart
				this.observe('rawHitsChartData showChartBandwidth usageChartGroupBy screenWidth', () => {
					let rawHitsChartData = this.get('rawHitsChartData');
					let noHitsChartHitsData = this.get('noHitsChartHitsData');
					let noHitsChartBandData = this.get('noHitsChartBandData');
					let showChartBandwidth = this.get('showChartBandwidth');
					let topTablesLimit = this.get('topTablesLimit');
					let colorsArray = this.get('colorsArray');

					if (
						!rawHitsChartData
						|| (noHitsChartHitsData && !showChartBandwidth)
						|| (noHitsChartBandData && showChartBandwidth)
						|| (noHitsChartHitsData && noHitsChartBandData)
					) { return; }

					let chartPeriodType = this.get('periodData').periodType;
					let usageChartGroupBy = this.get('usageChartGroupBy');
					let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;

					// collect versions for hitsChart Legend element
					let hitsChartLegendVersions = rawHitsChartData.map(item => ({ version: item.version }));

					// collect X-Axis dates, group data by period, get
					let {
						labels,
						maxRangeValue,
						datasets,
						labelsStartEndPeriods,
						valueUnits,
					} = _.getPreparedDataForLineChart(
						rawHitsChartData,
						usageChartGroupBy,
						chartPeriodType,
						showChartBandwidth,
						topTablesLimit,
						true,
						colorsArray,
					);

					this.set('preparedHitsChartData', {
						datasets,
						labels,
						labelsStartEndPeriods,
						maxRangeValue,
						showChartBandwidth,
						useYAxisBorderPlugin: screenWidth >= 768,
						yAxisPadding: screenWidth >= 768 ? 30 : 18,
						valueUnits,
						usageChartGroupBy,
					});

					this.set('hitsChartLegendVersions', hitsChartLegendVersions);
				}, { init: false, defer: true });

				// set Chart text based on periodData
				this.observe('periodData', ({ periodValue }) => {
					switch (periodValue) {
						case 'month':
						case 'quarter':
						case 'year':
							this.set('chartTitlePeriodText', 'Stats for past');
							break;
						default:
							this.set('chartTitlePeriodText', 'Stats for');
					}
				});

				// handle case when no data for the Package at all
				this.observe('noStatsChartHitsData noStatsChartBandData noHitsChartHitsData noHitsChartBandData noTopFiveHitsData noTopFiveBandData', () => {
					let noStatsChartHitsData = this.get('noStatsChartHitsData');
					let noStatsChartBandData = this.get('noStatsChartBandData');
					let noHitsChartHitsData = this.get('noHitsChartHitsData');
					let noHitsChartBandData = this.get('noHitsChartBandData');
					let noTopFiveHitsData = this.get('noTopFiveHitsData');
					let noTopFiveBandData = this.get('noTopFiveBandData');

					if (
						noStatsChartHitsData
						&& noStatsChartBandData
						&& noHitsChartHitsData
						&& noHitsChartBandData
						&& noTopFiveHitsData
						&& noTopFiveBandData
					) {
						this.set('showChartBandwidth', false);
						this.set('noPackageStatsData', true);
					} else {
						this.set('noPackageStatsData', false);
					}
				});
			}
		},
		onrender () {
			if (!Ractive.isServer) {
				let statsChart;
				let hitsChart;

				initCharts().then(({ createBarChart, createLineChart }) => {
					// create barChart
					this.observe('preparedStatsChartData', (preparedStatsChartData) => {
						if (!preparedStatsChartData) { return; }

						let {
							labels,
							maxRangeValue,
							data,
							showChartBandwidth,
							barThickness,
							useYAxisBorderPlugin,
							yAxisPadding,
							labelsStartEndPeriods,
							valueUnits,
							usageChartGroupBy,
						} = preparedStatsChartData;
						let statsChartCanvasEl = this.find('#stats-chart');

						if (!preparedStatsChartData || !statsChartCanvasEl) { return; }

						if (statsChart) {
							statsChart.destroy();
							statsChart = null;
						}

						let chartData = {
							labels,
							datasets: [{
								data,
								borderWidth: 0,
								barThickness,
								hoverBackgroundColor: '#F65128',
							}],
							labelsStartEndPeriods,
							valueUnits,
							usageChartGroupBy,
						};
						let chartSettings = {
							useYAxisBorderPlugin,
							useExternalTooltip: true,
							useImprovedTooltip: true,
							externalTooltipVerticalOffset: 40,
						};
						let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
						let chartConfig = {
							options: {
								scales: {
									x: {
										display: true,
										ticks: {
											color: '#5C667A',
											font: {
												size: 12,
												family: 'Lexend, sans-serif',
												lineHeight: 2,
											},
											// return nothing when labelValue array is empty
											// this way we will not get italicized text when all ticks can't be displayed at once normally
											callback (value) {
												let labelValue = this.getLabelForValue(value);

												if (labelValue.length) {
													return labelValue;
												}
											},
										},
										grid: {
											display: false,
										},
										border: {
											display: false,
										},
									},
									y: {
										display: true,
										min: 0,
										suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
										ticks: {
											padding: yAxisPadding,
											count: 9,
											color: '#5C667A',
											crossAlign: 'near',
											font: {
												size: 12,
												family: 'Lexend, sans-serif',
											},
											callback (value) {
												let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);

												if (_.isMobileScreen()) {
													return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
												}

												return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
											},
										},
										grid: {
											display: false,
										},
										border: {
											display: false,
										},
									},
								},
							},
						};

						statsChart = createBarChart(statsChartCanvasEl, chartData, chartSettings, chartConfig);
					});

					// create lineChart
					this.observe('preparedHitsChartData', (preparedHitsChartData) => {
						if (!preparedHitsChartData) { return; }

						let {
							datasets,
							labels,
							maxRangeValue,
							useYAxisBorderPlugin,
							showChartBandwidth,
							yAxisPadding,
							labelsStartEndPeriods,
							valueUnits,
							usageChartGroupBy,
						} = preparedHitsChartData;
						let hitsChartCanvasEl = this.find('#hits-chart');

						if (!preparedHitsChartData || !hitsChartCanvasEl) { return; }

						if (hitsChart) {
							hitsChart.destroy();
							hitsChart = null;
						}

						let chartData = {
							labels,
							datasets,
							labelsStartEndPeriods,
							valueUnits,
							usageChartGroupBy,
						};
						let chartSettings = {
							useYAxisBorderPlugin,
							useExternalTooltip: true,
							useImprovedTooltip: true,
							noSpaceForImprvdTltp: true,
							plugins: {
								useExternalTooltip: true,
							},
						};
						let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
						let chartConfig = {
							options: {
								scales: {
									x: {
										display: true,
										ticks: {
											autoSkip: false,
											color: '#5C667A',
											font: {
												size: 12,
												family: 'Lexend, sans-serif',
												lineHeight: 2,
											},
											callback (value) {
												let labelValue = this.getLabelForValue(value);

												if (labelValue.length) {
													return labelValue;
												}
											},
										},
										grid: {
											display: false,
										},
										border: {
											display: false,
										},
									},
									y: {
										display: true,
										min: 0,
										suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
										ticks: {
											padding: yAxisPadding,
											count: 9,
											color: '#5C667A',
											crossAlign: 'near',
											font: {
												size: 12,
												family: 'Lexend, sans-serif',
											},
											callback (value) {
												let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);

												if (_.isMobileScreen()) {
													return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
												}

												return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
											},
										},
										grid: {
											color: '#CFD6DD',
											tickLength: 0,
										},
										border: {
											display: false,
										},
									},
								},
							},
						};

						hitsChart = createLineChart(hitsChartCanvasEl, chartData, chartSettings, chartConfig);
					});
				});

				listeners.screenWidthListener(this);
			}
		},

		handlePeriodSelecting () {
			return (periodData) => {
				this.set('periodData', periodData);
			};
		},
		checkPackageVersionsDataStatus (response) {
			return response.reduce((res, data) => {
				if (data.hits.total) {
					res.noHitsData = false;
				}

				if (data.bandwidth.total) {
					res.noBandwidthData = false;
				}

				return res;
			}, { noHitsData: true, noBandwidthData: true });
		},
	};
</script>
